import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
// 导入全局变量
import globalVariable from './api/global_variable.js'
// 导入axios
import axios from 'axios'
// 导入全局样式表
import './assets/css/global.css'
// 视频
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

Vue.config.productionTip = false

Vue.prototype.GLOBAL = globalVariable

// 导入axios
axios.defaults.baseURL = ''

Vue.prototype.$http = axios

Vue.use(VideoPlayer)

const vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default vue
